import { Injectable, Type } from '@angular/core';
import { LessonComponentEnum } from '../lesson-mini-components/components/lessons.clases';
import { SpeakerBuilderComponent } from '../lesson-mini-components/components/speaker/speaker-builder/speaker-builder.component';
import { SpeakerComponent } from '../lesson-mini-components/components/speaker/speaker.component';

export interface InputCompoennt {
  text?: string; // Text is the text will extract in case of show as text and not component.
  [key: string]: any;
}

export interface DynamicComponentData {
  id?: string;
  component: LessonComponentEnum;
  inputs?: InputCompoennt; // for whatever component.
}

// TODO: check LessonComponentBuilders in lessons.clases.ts for origianl implementation
export const DynamicComponentBuilders = {
  [LessonComponentEnum.Speaker]: SpeakerBuilderComponent,
};

export const DynamicComponents = {
  [LessonComponentEnum.Speaker]: SpeakerComponent,
};

@Injectable({
  providedIn: 'root',
})
export class DynamicComponentsService {
  private _dynamicComponentBuilders = { ...DynamicComponentBuilders };
  private _dynamicComponents = { ...DynamicComponents };

  public registerCustomComponent(component: Type<any>, name?: string) {
    // this._dynamicComponentBuilders[name || component.name] = component;
    this._dynamicComponents[name || component.name] = component;
  }

  public registerCustomComponentBuilder(component: Type<any>, name?: string) {
    this._dynamicComponentBuilders[name || component.name] = component;
  }

  public getDynamicComponentBuilders(type: any) {
    return this._dynamicComponentBuilders[type];
  }

  public getDynamicComponentClass(type: LessonComponentEnum | string) {
    return this._dynamicComponents[type];
  }
}
